export default __webpack_public_path__ + "static/media/doctor-kelvin.d296f3cb.png";